var _regeneratorRuntime = require("/workspace/node_modules/@babel/runtime/regenerator/index.js");

var _taggedTemplateLiteral = require("/workspace/node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js");

var _asyncToGenerator = require("/workspace/node_modules/@babel/runtime/helpers/asyncToGenerator.js");

var _templateObject, _templateObject2;

var pageResults = require('graph-results-pager');

var ws = require('isomorphic-ws');

var _require = require('subscriptions-transport-ws'),
    SubscriptionClient = _require.SubscriptionClient;

var _require2 = require('graphql-request'),
    request = _require2.request,
    gql = _require2.gql;

var _require3 = require('./../constants'),
    graphAPIEndpoints = _require3.graphAPIEndpoints,
    graphWSEndpoints = _require3.graphWSEndpoints,
    makerAddress = _require3.makerAddress;

var _require4 = require('./../utils'),
    timestampToBlock = _require4.timestampToBlock;

module.exports = {
  info: function info() {
    var _arguments = arguments;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _ref, _ref$block, block, _ref$timestamp, timestamp, result;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _ref = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : {}, _ref$block = _ref.block, block = _ref$block === void 0 ? undefined : _ref$block, _ref$timestamp = _ref.timestamp, timestamp = _ref$timestamp === void 0 ? undefined : _ref$timestamp;

              if (!block) {
                _context.next = 5;
                break;
              }

              _context.t0 = block;
              _context.next = 13;
              break;

            case 5:
              if (!timestamp) {
                _context.next = 11;
                break;
              }

              _context.next = 8;
              return timestampToBlock(timestamp);

            case 8:
              _context.t1 = _context.sent;
              _context.next = 12;
              break;

            case 11:
              _context.t1 = undefined;

            case 12:
              _context.t0 = _context.t1;

            case 13:
              block = _context.t0;
              block = block ? "block: { number: ".concat(block, " }") : "";
              _context.next = 17;
              return request(graphAPIEndpoints.maker, gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["{\n                    makers(first: 1, ", ") {\n                        ", "\n                    }\n                }"])), block, _info.properties.toString()));

            case 17:
              result = _context.sent;
              return _context.abrupt("return", _info.callback(result.makers[0]));

            case 19:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  servings: function servings() {
    var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref2$minTimestamp = _ref2.minTimestamp,
        minTimestamp = _ref2$minTimestamp === void 0 ? undefined : _ref2$minTimestamp,
        _ref2$maxTimestamp = _ref2.maxTimestamp,
        maxTimestamp = _ref2$maxTimestamp === void 0 ? undefined : _ref2$maxTimestamp,
        _ref2$minBlock = _ref2.minBlock,
        minBlock = _ref2$minBlock === void 0 ? undefined : _ref2$minBlock,
        _ref2$maxBlock = _ref2.maxBlock,
        maxBlock = _ref2$maxBlock === void 0 ? undefined : _ref2$maxBlock,
        _ref2$max = _ref2.max,
        max = _ref2$max === void 0 ? undefined : _ref2$max;

    return pageResults({
      api: graphAPIEndpoints.maker,
      query: {
        entity: 'servings',
        selection: {
          where: {
            block_gte: minBlock || undefined,
            block_lte: maxBlock || undefined,
            timestamp_gte: minTimestamp || undefined,
            timestamp_lte: maxTimestamp || undefined
          }
        },
        properties: _servings.properties
      },
      max: max
    }).then(function (results) {
      return _servings.callback(results);
    }).catch(function (err) {
      return console.log(err);
    });
  },
  servers: function servers() {
    var _arguments2 = arguments;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var _ref3, _ref3$block, block, _ref3$timestamp, timestamp, _ref3$max, max;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _ref3 = _arguments2.length > 0 && _arguments2[0] !== undefined ? _arguments2[0] : {}, _ref3$block = _ref3.block, block = _ref3$block === void 0 ? undefined : _ref3$block, _ref3$timestamp = _ref3.timestamp, timestamp = _ref3$timestamp === void 0 ? undefined : _ref3$timestamp, _ref3$max = _ref3.max, max = _ref3$max === void 0 ? undefined : _ref3$max;
              _context2.t0 = pageResults;
              _context2.t1 = graphAPIEndpoints.maker;

              if (!block) {
                _context2.next = 7;
                break;
              }

              _context2.t2 = {
                number: block
              };
              _context2.next = 16;
              break;

            case 7:
              if (!timestamp) {
                _context2.next = 14;
                break;
              }

              _context2.next = 10;
              return timestampToBlock(timestamp);

            case 10:
              _context2.t4 = _context2.sent;
              _context2.t3 = {
                number: _context2.t4
              };
              _context2.next = 15;
              break;

            case 14:
              _context2.t3 = undefined;

            case 15:
              _context2.t2 = _context2.t3;

            case 16:
              _context2.t5 = _context2.t2;
              _context2.t6 = _servers.properties;
              _context2.t7 = {
                entity: 'servers',
                block: _context2.t5,
                properties: _context2.t6
              };
              _context2.t8 = max;
              _context2.t9 = {
                api: _context2.t1,
                query: _context2.t7,
                max: _context2.t8
              };
              return _context2.abrupt("return", (0, _context2.t0)(_context2.t9).then(function (results) {
                return _servers.callback(results);
              }).catch(function (err) {
                return console.log(err);
              }));

            case 22:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  },
  pendingServings: function pendingServings() {
    var _arguments3 = arguments;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      var _ref4, _ref4$block, block, _ref4$timestamp, timestamp, _ref4$max, max;

      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _ref4 = _arguments3.length > 0 && _arguments3[0] !== undefined ? _arguments3[0] : {}, _ref4$block = _ref4.block, block = _ref4$block === void 0 ? undefined : _ref4$block, _ref4$timestamp = _ref4.timestamp, timestamp = _ref4$timestamp === void 0 ? undefined : _ref4$timestamp, _ref4$max = _ref4.max, max = _ref4$max === void 0 ? undefined : _ref4$max;
              _context3.t0 = pageResults;
              _context3.t1 = graphAPIEndpoints.exchange;
              _context3.t2 = {
                where: {
                  id: "\\\"".concat(makerAddress, "\\\"")
                }
              };

              if (!block) {
                _context3.next = 8;
                break;
              }

              _context3.t3 = {
                number: block
              };
              _context3.next = 17;
              break;

            case 8:
              if (!timestamp) {
                _context3.next = 15;
                break;
              }

              _context3.next = 11;
              return timestampToBlock(timestamp);

            case 11:
              _context3.t5 = _context3.sent;
              _context3.t4 = {
                number: _context3.t5
              };
              _context3.next = 16;
              break;

            case 15:
              _context3.t4 = undefined;

            case 16:
              _context3.t3 = _context3.t4;

            case 17:
              _context3.t6 = _context3.t3;
              _context3.t7 = _pendingServings.properties;
              _context3.t8 = {
                entity: 'users',
                selection: _context3.t2,
                block: _context3.t6,
                properties: _context3.t7
              };
              _context3.t9 = max;
              _context3.t10 = {
                api: _context3.t1,
                query: _context3.t8,
                max: _context3.t9
              };
              return _context3.abrupt("return", (0, _context3.t0)(_context3.t10).then(function (results) {
                return _pendingServings.callback(results);
              }).catch(function (err) {
                return console.log(err);
              }));

            case 23:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }))();
  },
  observePendingServings: function observePendingServings() {
    var query = gql(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n            subscription {\n                users(first: 1000, where: {id: \"", "\"}) {\n                    ", "\n                }\n        }"])), makerAddress, _pendingServings.properties.toString());
    var client = new SubscriptionClient(graphWSEndpoints.exchange, {
      reconnect: true
    }, ws);
    var observable = client.request({
      query: query
    });
    return {
      subscribe: function subscribe(_ref5) {
        var _next = _ref5.next,
            error = _ref5.error,
            complete = _ref5.complete;
        return observable.subscribe({
          next: function next(results) {
            _next(_pendingServings.callback(results.data.users));
          },
          error: error,
          complete: complete
        });
      }
    };
  }
};
var _info = {
  properties: ['id', 'sushiServed'],
  callback: function callback(results) {
    return {
      address: results.id,
      sushiServed: Number(results.sushiServed)
    };
  }
};
var _servings = {
  properties: ['server { id }', 'tx', 'pair', 'token0', 'token1', 'sushiServed', 'block', 'timestamp'],
  callback: function callback(results) {
    return results.map(function (_ref6) {
      var server = _ref6.server,
          tx = _ref6.tx,
          pair = _ref6.pair,
          token0 = _ref6.token0,
          token1 = _ref6.token1,
          sushiServed = _ref6.sushiServed,
          block = _ref6.block,
          timestamp = _ref6.timestamp;
      return {
        serverAddress: server.id,
        tx: tx,
        pair: pair,
        token0: token0,
        token1: token1,
        sushiServed: Number(sushiServed),
        block: Number(block),
        timestamp: Number(timestamp * 1000),
        date: new Date(timestamp * 1000)
      };
    });
  }
};
var _servers = {
  properties: ['id', 'sushiServed', 'servings(first: 1000, orderBy: block, orderDirection: desc) { tx, block, pair, sushiServed }'],
  callback: function callback(results) {
    return results.map(function (_ref7) {
      var id = _ref7.id,
          sushiServed = _ref7.sushiServed,
          servings = _ref7.servings;
      return {
        serverAddress: id,
        sushiServed: Number(sushiServed),
        servings: servings.map(function (_ref8) {
          var tx = _ref8.tx,
              block = _ref8.block,
              pair = _ref8.pair,
              sushiServed = _ref8.sushiServed;
          return {
            tx: tx,
            block: Number(block),
            pair: pair,
            sushiServed: Number(sushiServed)
          };
        })
      };
    });
  }
};
var _pendingServings = {
  properties: ['liquidityPositions(first: 1000) { id, liquidityTokenBalance, pair { id, totalSupply, reserveUSD, token0 { id, name, symbol }, token1 { id, symbol, name } } }'],
  callback: function callback(results) {
    return results[0].liquidityPositions.map(function (_ref9) {
      var liquidityTokenBalance = _ref9.liquidityTokenBalance,
          pair = _ref9.pair;
      return {
        address: pair.id,
        token0: pair.token0,
        token1: pair.token1,
        valueUSD: liquidityTokenBalance / pair.totalSupply * pair.reserveUSD
      };
    }).sort(function (a, b) {
      return b.valueUSD - a.valueUSD;
    });
  }
};